import { useEffect, useState } from 'react';
import LoggedLayout from 'layouts/LoggedLayout';
import axios from 'axios';

let axiosCancelToken = null;

export default function MiddlewareStations() {
	let [stations, setStations] = useState([]);

	useEffect(() => {
		axiosCancelToken = axios.CancelToken.source();

		const getStations = async () => {
			return axios.get('api/middleware-stations/list', {
				params: {},
				cancelToken: axiosCancelToken.token
			}).then((response) => {
		    	setStations(response.data);
		  	}).catch((error) => {
				if ( axios.isCancel(error) ) return;
			});
		}

		getStations();

		return function cleanup() {
           	axiosCancelToken.cancel();
        }
	}, []);

	return (
		<LoggedLayout>
			<div className="col-md-12 mb-3">
				<h4 className="mb-0">Listado de estaciones</h4>
				<small>Este listado de estaciones es informativo. Estas estaciones vienen del listado de estaciones del <u>Middleware</u>. Para añadir o borrar una estación, contacte con el administrador del <u>Middleware</u>.</small>
			</div>

			<div className="col-md-12 mb-3">
				<div className="table-responsive">
					<table className="table table-bordered bg-white">
						<thead>
							<tr className="bg-plenoil-primary text-white">
								<th>Nombre</th>
								<th>Octan ID</th>
								<th>IP</th>
								<th>IP Backup</th>
								<th>Puerto</th>
								<th>Usuario</th>
							</tr>
						</thead>
						<tbody>
							{ stations.map((el, idx) => {
								return (
									<tr key={idx}>
										<td>{el.name}</td>
										<td>{el.octan_id}</td>
										<td>{el.ip}</td>
										<td>{el.ip_backup}</td>
										<td>{el.port}</td>
										<td>{el.user}</td>
									</tr>
								)
							}) }
							{ !stations.length && <tr key="empty"><td colSpan="100%">No hay estaciones</td></tr> }
						</tbody>
					</table>
				</div>
			</div>
		</LoggedLayout>
	);
}


